import { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { useAppDispatch, useAppSelector } from '@store'
import { selectAlert, setShowAlert } from '@store/alert'
import { SuccessIcon, ErrorIcon } from '../icons'
import * as S from './styled'

const iconsByType = {
  success: <SuccessIcon />,
  error: <ErrorIcon />,
}

export const Alert = ({ withClose = false }) => {
  const dispatch = useAppDispatch()
  const { show, message, type } = useAppSelector(selectAlert)
  const [clear, setClear] = useState(false)
  const clearErrorRef = useRef(() => dispatch(setShowAlert(false)))
  const onCloseClick = (): void => {
    setClear(true)
    clearErrorRef.current()
  }

  useEffect(() => {
    clearErrorRef.current = () => dispatch(setShowAlert(false))
  }, [dispatch])

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | undefined

    if (show && !clear) {
      timer = setTimeout(() => clearErrorRef.current(), 3000)
    }
    return () => {
      setClear(false)
      if (timer) clearTimeout(timer)
    }
  }, [show, clear])

  return createPortal(
    <S.StyledAlert $show={show} $type={type}>
      {iconsByType[type]}
      {typeof message === 'string' ? (
        <S.MessageBlock>{message}</S.MessageBlock>
      ) : (
        <S.MessageBlock>
          <div>{message.title}</div>
          <div style={{ fontWeight: 400 }}>{message.description}</div>
        </S.MessageBlock>
      )}
      {withClose && (
        <S.CloseAlert id={'close-alert'} onClick={onCloseClick}>
          ×
        </S.CloseAlert>
      )}
    </S.StyledAlert>,
    document.body,
  )
}
